import React from 'react';
import PropTypes from 'prop-types';
import '../styles/text-loader.scss';

const TextLoader = ({
  text = 'LOADING',
  className = '',
  primaryColor = '#11307C',
  secondaryColor = '#88B3E0',
  size = 'medium',
}) => {
  const sizeClasses = {
    small: 'text-loader--small',
    medium: 'text-loader--medium',
    large: 'text-loader--large',
  };

  const loaderClass = `loader ${sizeClasses[size]} ${className}`.trim();

  return (
    <div
      className={loaderClass}
      style={{
        '--primary-color': primaryColor,
        '--secondary-color': secondaryColor,
      }}
      role="status"
      aria-label="Loading"
    >
      <p className="loader-text">{text}</p>
      <span className="load" />
    </div>
  );
};

TextLoader.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};

TextLoader.defaultProps = {
  text: 'LOADING',
  className: '',
  primaryColor: '#11307C',
  secondaryColor: '#88B3E0',
  size: 'medium',
};

export default TextLoader;
